import { Fetch } from "../../shared/Fetch";
import { Submission, Requirement, SubmissionDayWise, RequirementDayWise, POs, ECIs, Margin } from "./DashboardModel";


// To fetch data from API's
const getData=async (link:string)=>{
    const response = await Fetch(`${link}`, "GET", null, null, null);
    const data = await response?.json();
    return data;
}

// Fetch all data.
export const getBranchRequirments=async ()=>{

    const data=await getData("Dashboard/requirement");
    
    let arr:Requirement[]=[];

    data.forEach((el:any)=>{
        let company=el.companyName.split(" ");
        let obj:Requirement={
            branchName:`${el.branchName} (${company[0]})`,
            totalRequirement:el.totalRequirement,
            totalAllocation:el.totalAllocation,
            totalServices:el.servedCount,
            serving:el.subCount,
        };
        arr.push(obj);
    });

    return getBranchRequirmentDayWise(arr);
}

export const getBranchSubmissions=async ()=>{

    const data=await getData("dashboard/submission");

    let arr:Submission[]=[];

    data.forEach((el:any)=>{
        let company=el.companyName.split(" ");
        let obj:Submission={
            branchName:`${el.branchName} (${company[0]})`,
            totalSubmission:el.totalSubmission,
            totalSalesRejected:el.totalSalesRejected,
            totalPVRejected:el.totalPVRejected,
            totalEndClientSubmission:el.totalEndClientSubmission,
        };
        arr.push(obj);
    });

    return getBranchSubmissionDayWise(arr);
}

export const getBranchECIs=async ()=>{

    const data=await getData("Dashboard/eci");

    let arr:ECIs[]=[];

    if(data.length>0){
        data.forEach((el:any)=>{
            let company=el.companyName.split(" ");
            let obj:ECIs={
                branchName:`${el.branchName} (${company[0]})`,
                totalECI:el.totalECI,
                totalBackoutECI:el.totalBackoutECI,
                totalConfirmedECI:el.totalConfirmedECI,
                totalRescheduledECI:el.totalRescheduledECI,
            };
    
            arr.push(obj);
        });
    }


    return getBranchECIDayWise(arr);
}

export const getBranchPOs=async ()=>{

    const data=await getData("Dashboard/po");

    let arr:POs[]=[];

    data.forEach((el:any)=>{
        let company=el.companyName.split(" ");
        let obj:POs={
            branchName:`${el.branchName} (${company[0]})`,
            totalPO:el.totalPO,
            totalRunningPO:el.totalRunningPO,
            totalEndedPO:el.totalEndedPO,
            totalFizzledPO:el.totalFizzledPO,
        };

        arr.push(obj);
    });

    return getBranchPODayWise(arr);
}

export const getBranchMargins=async ()=>{

    const data=await getData("Dashboard/margin");

    let arr:Margin[]=[];

    data.forEach((el:any)=>{
        let company=el.companyName.split(" ");
        let obj:Margin={
            branchName:`${el.branchName} (${company[0]})`,
            totalMargin:el.totalMargin,
            totalRunningMargin:el.totalRunningMargin,
            totalEndedMargin:el.totalEndedMargin,
            totalFizzledMargin:el.totalFizzledMargin,
        };

        arr.push(obj);
    });

    return getBranchMarginDayWise(arr);
}






// Fetch data according day wise.

export const getBranchRequirmentDayWise=async (resp:Requirement[])=>{
    
    const data:RequirementDayWise=await getData("Dashboard/requirementDayWise");

    let day:Requirement={
        branchName:"Day Total",
        totalRequirement:data.dayTotalReq,
        totalAllocation:data.dayTotalAllocation,
        totalServices:data.dayTotalServed,
        serving:data.dayTotalSub,
    }

    let week:Requirement={
        branchName:"Week Total",
        totalRequirement:data.weekTotalReq,
        totalAllocation:data.weekTotalAllocation,
        totalServices:data.weekTotalServed,
        serving:data.weekTotalSub,
    }

    let month:Requirement={
        branchName:"Month Total",
        totalRequirement:data.monthTotalReq,
        totalAllocation:data.monthTotalAllocation,
        totalServices:data.monthTotalServed,
        serving:data.monthTotalSub,
    }

    resp=[...resp,day,week,month];

    return resp;

}

export const getBranchSubmissionDayWise=async(resp:Submission[])=>{

    const data:SubmissionDayWise=await getData("dashboard/submissionDayWise");
    
    let day:Submission={
        branchName:"Day Total",
        totalSubmission:data.dayTotalSubmission,
        totalSalesRejected:data.dayTotalSalesRejected,
        totalPVRejected:data.dayTotalPVRejected,
        totalEndClientSubmission:data.dayTotalEndClientSub,
    }

    let week:Submission={
        branchName:"Week Total",
        totalSubmission:data.weekTotalSubmission,
        totalSalesRejected:data.weekTotalSalesRejected,
        totalPVRejected:data.weekTotalPVRejected,
        totalEndClientSubmission:data.weekTotalEndClientSub,
    }

    let month:Submission={
        branchName:"Month Total",
        totalSubmission:data.monthTotalSubmission,
        totalSalesRejected:data.monthTotalSalesRejected,
        totalPVRejected:data.monthTotalPVRejected,
        totalEndClientSubmission:data.monthTotalEndClientSub,
    }

    resp=[...resp,day,week,month];

    return resp;

}

export const getBranchECIDayWise=async(resp:ECIs[])=>{

    const data=await getData("Dashboard/eciDayWise");
    
    let day:ECIs={
        branchName:"Day Total",
        totalECI:data.dayTotalECI,
        totalBackoutECI:data.dayTotalBackoutECI,
        totalConfirmedECI:data.dayTotalConfirmedECI,
        totalRescheduledECI:data.dayTotalRescheduledECI,
    }

    let week:ECIs={
        branchName:"Week Total",
        totalECI:data.weekTotalECI,
        totalBackoutECI:data.weekTotalBackoutECI,
        totalConfirmedECI:data.weekTotalConfirmedECI,
        totalRescheduledECI:data.weekTotalRescheduledECI,
    }

    let month:ECIs={
        branchName:"Month Total",
        totalECI:data.monthTotalECI,
        totalBackoutECI:data.monthTotalBackoutECI,
        totalConfirmedECI:data.monthTotalConfirmedECI,
        totalRescheduledECI:data.monthTotalRescheduledECI,
    }

    resp=[...resp,day,week,month];

    return resp;

}

export const getBranchPODayWise=async(resp:POs[])=>{

    const data=await getData("Dashboard/poDayWise");
    
    let day:POs={
        branchName:"Day Total",
        totalPO:data.dayTotalPO,
        totalRunningPO:data.dayTotalRunningPO,
        totalEndedPO:data.dayTotalEndedPO,
        totalFizzledPO:data.dayTotalFizzledPO,
    }

    let week:POs={
        branchName:"Week Total",
        totalPO:data.weekTotalPO,
        totalRunningPO:data.weekTotalRunningPO,
        totalEndedPO:data.weekTotalEndedPO,
        totalFizzledPO:data.weekTotalFizzledPO,
    }

    let month:POs={
        branchName:"Month Total",
        totalPO:data.monthTotalPO,
        totalRunningPO:data.monthTotalRunningPO,
        totalEndedPO:data.monthTotalEndedPO,
        totalFizzledPO:data.monthTotalFizzledPO,
    }

    resp=[...resp,day,week,month];

    return resp;

}

export const getBranchMarginDayWise=async(resp:Margin[])=>{

    const data=await getData("Dashboard/marginDayWise");
    
    let day:Margin={
        branchName:"Day Total",
        totalMargin:data.dayTotalMargin,
        totalRunningMargin:data.dayTotalRunningMargin,
        totalEndedMargin:data.dayTotalEndedMargin,
        totalFizzledMargin:data.dayTotalFizzledMargin,
    }

    let week:Margin={
        branchName:"Week Total",
        totalMargin:data.weekTotalMargin,
        totalRunningMargin:data.weekTotalRunningMargin,
        totalEndedMargin:data.weekTotalEndedMargin,
        totalFizzledMargin:data.weekTotalFizzledMargin,
    }

    let month:Margin={
        branchName:"Month Total",
        totalMargin:data.monthTotalMargin,
        totalRunningMargin:data.monthTotalRunningMargin,
        totalEndedMargin:data.monthTotalEndedMargin,
        totalFizzledMargin:data.monthTotalFizzledMargin,
    }

    resp=[...resp,day,week,month];

    return resp;

}